<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant="mini"
    app
    clipped
    permanent>
    <v-list-item class="pa-5">
      <v-img contain src="/api/1/admin/branding/logo" transition="scale-transition" />
    </v-list-item>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item
        v-for="page in rootPages"
        :key="page.name"
        :to="page.path"
        link
        color="primary"
      >
        <v-list-item-icon>
          <v-icon>{{ page.meta.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ page.meta.bcText }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{name: 'Notifications'}" link color="primary">
        <v-list-item-icon>
          <v-badge
            color="primary"
            light
            :content="$store.state.notificationCounter"
            :value="$store.state.notificationCounter"
            overlap>
            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Notifications</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-btn
        icon
        @click.stop="mini = !mini"
        class="mr-5 mb-3"
        style="float: right"
      >
        <v-icon>{{ mini ? "mdi-chevron-right" : "mdi-chevron-left" }}</v-icon>
      </v-btn>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Drawer",
  data() {
    return {
      active: false,
      drawer: true,
      mini: false,
    }
  },
  computed: {
    pages() {
      return this.$router.options.routes.filter((page) => {
        return page.meta.listed
      })
    },
    rootPages() {
      return this.pages.filter((page) => {
        if (!page.meta.group) return true
        return false
      })
    },
  },
  methods: {
    nestedPages(group) {
      return this.pages.filter((page) => {
        if (page.meta.group === group) return true
        return false
      })
    },
  },
}
</script>

<style scoped>
.v-list-item__title {
  font-weight: 400 !important;
  font-size: 14px !important;
}
.v-navigation-drawer {
  padding-top: 10px;
  padding-bottom: 10px;
}
.v-img {
  padding: 10px 10px;
}
</style>
